import api from "..";
import { Setup } from "./types";
import useSWR from "swr";

export const SetupByKeyFetch = (key: string) => {
  const { data, mutate, isLoading } = useSWR<Setup>(
    `setup_by_key_${key}`,
    async (): Promise<Setup> => {
      const { data } = await api.get<Setup>(`/api/setups/ecommerce/${key}`);
      return data;
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return { data, mutate, isLoading };
};
